import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { PageHeader } from "@/components/kit";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Save } from "lucide-react";

export default function TherapistProfile() {
  const { user, refresh } = useAuth();
  const [form, setForm] = useState(null);

  useEffect(() => {
    if (user) setForm({
      name: user.name || "", photo: user.profile?.photo || "", bio: user.profile?.bio || "",
      specialties: user.profile?.specialties || "", phone: user.profile?.phone || user.phone || "",
      whatsapp: user.profile?.whatsapp || "", instagram: user.profile?.instagram || "",
      site: user.profile?.site || "", city: user.profile?.city || user.city || "",
      modality: user.profile?.modality || "", schedule: user.profile?.schedule || "",
      address: user.profile?.address || "", meeting_link: user.profile?.meeting_link || "",
    });
  }, [user]);

  if (!form) return null;
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => { await api.put("/therapist/profile", form); await refresh(); toast.success("Perfil atualizado"); };

  return (
    <div>
      <PageHeader title="Meu Perfil" subtitle="Estas informações são apresentadas aos seus clientes"
        action={<Button onClick={save} className="rounded-full" data-testid="save-profile-btn"><Save className="w-4 h-4 mr-1" />Salvar</Button>} />
      <Card className="p-6 max-w-3xl">
        <div className="flex items-center gap-4 mb-6">
          <Avatar className="w-16 h-16"><AvatarImage src={form.photo} /><AvatarFallback className="bg-primary/10 text-primary text-xl">{form.name[0]}</AvatarFallback></Avatar>
          <div className="flex-1"><Label>Foto (URL)</Label><Input value={form.photo} onChange={set("photo")} className="mt-1" placeholder="https://" /></div>
        </div>
        <div className="grid sm:grid-cols-2 gap-4">
          <div><Label>Nome profissional</Label><Input value={form.name} onChange={set("name")} data-testid="profile-name-input" className="mt-1" /></div>
          <div><Label>Especialidades</Label><Input value={form.specialties} onChange={set("specialties")} className="mt-1" placeholder="Ansiedade, Sono..." /></div>
          <div className="sm:col-span-2"><Label>Descrição</Label><Textarea value={form.bio} onChange={set("bio")} className="mt-1" rows={3} /></div>
          <div><Label>Telefone</Label><Input value={form.phone} onChange={set("phone")} className="mt-1" /></div>
          <div><Label>WhatsApp</Label><Input value={form.whatsapp} onChange={set("whatsapp")} className="mt-1" placeholder="5511999999999" /></div>
          <div><Label>Instagram</Label><Input value={form.instagram} onChange={set("instagram")} className="mt-1" placeholder="@usuario" /></div>
          <div><Label>Site</Label><Input value={form.site} onChange={set("site")} className="mt-1" /></div>
          <div><Label>Cidade</Label><Input value={form.city} onChange={set("city")} className="mt-1" /></div>
          <div><Label>Modalidade de atendimento</Label><Input value={form.modality} onChange={set("modality")} className="mt-1" placeholder="Presencial e Online" /></div>
          <div><Label>Endereço (presencial)</Label><Input value={form.address} onChange={set("address")} className="mt-1" placeholder="Rua, nº, bairro, cidade" data-testid="profile-address-input" /></div>
          <div><Label>Link de atendimento online</Label><Input value={form.meeting_link} onChange={set("meeting_link")} className="mt-1" placeholder="https://meet.google.com/... ou Zoom" data-testid="profile-link-input" /></div>
          <div className="sm:col-span-2"><Label>Horários</Label><Input value={form.schedule} onChange={set("schedule")} className="mt-1" placeholder="Seg a Sex, 9h às 18h" /></div>
        </div>
      </Card>
    </div>
  );
}
